import { flow } from 'lodash';
import { connect } from 'react-redux';
import ReviewSheet from './ReviewSheet';

const mapStateToProps = state => ({
  review: state.task.review
});

export default flow(connect(mapStateToProps))(ReviewSheet);



// WEBPACK FOOTER //
// ../core/src/components/ReviewSheet/index.js